export const PRIMARY_COLOR = '#315eff';
export const PRIMARY_COLOR_LIGHT = '#4378ff';
export const PRIMARY_COLOR_DARK = '#2e3471';
export const PRIMARY_DARK_GREY_COLOR = '#222222';
export const PRIMARY_DARK_GREY_COLOR_TWO = '#333';
export const PRIMARY_LIGHT_GREY_COLOR = '#f7f7f7';
export const PRIMARY_LIGHT_GREY_COLOR_TWO = '#eee';
export const PRIMARY_LIGHT_GREY_COLOR_THREE = '#999999';
